<div class="notes-container">
  <div class="notes-header">
    <oph-icon name="file-brown" [size]="20"></oph-icon>
    <h2>Notes</h2>
    <oph-x-button (buttonClick)="closeNotes.emit()"> </oph-x-button>
  </div>
  <div class="notes-content">
    <div class="notes-input-section">
      <oph-input-orange
        [control]="$any(noteForm.get('note'))"
        [inputStyle]="{height: '42px', borderRadius: '6px', fontSize: '16px', backgroundColor: 'var(--white)'}"
      ></oph-input-orange>
      <input
        type="file"
        class="file-input"
        (change)="onFileSelected($event)"
        #fileUpload
        accept="image/*"
        style="display: none"
      />
      @if (noteForm.get('images').value?.length) {
        <div class="image-previews">
          @for (image of noteForm.get('images').value; track image; let imageIndex = $index) {
            <div class="image-preview-container" [class.loading]="(imageLoading$ | async)?.[imageIndex]">
              <img [src]="tempImageUrls[imageIndex] || image" class="preview-image" />
              @if ((imageLoading$ | async)?.[imageIndex]) {
                <div class="loading-overlay">
                  <div class="oph-white-spinner">
                    <mat-spinner
                      class="avatar-spinner"
                      mode="determinate"
                      [value]="(uploadProgress$ | async)?.[imageIndex] || 0"
                      [diameter]="30"
                    ></mat-spinner>
                  </div>
                </div>
              } @else {
                <div class="delete-overlay">
                  <button class="delete-button" (click)="onDeleteImage(imageIndex)">
                    <oph-icon name="delete-white" [size]="20"></oph-icon>
                  </button>
                </div>
              }
            </div>
          }
        </div>
      }
      <div class="notes-button-container">
        <button class="upload-photo-button" (click)="onUploadPhotoClick()">
          Upload Photo
          <oph-icon name="camera-current-sked" [size]="16"></oph-icon>
        </button>

        <oph-button
          color="brown"
          size="medium"
          (buttonClick)="onPost()"
          [style]="{borderRadius: '10px'}"
          [loading]="notePostLoading$ | async"
          [disabled]="
            (!noteForm.get('note').value && !noteForm.get('images').value?.length) ||
            hasLoadingImages(imageLoading$ | async)
          "
          >Post</oph-button
        >
      </div>
    </div>

    <div class="notes-list oph-scroll-bar">
      @for (note of reversedNotes(); track note) {
        <div class="note">
          <span class="username">{{ (usersMap$ | async)[note.createdBy]?.username || 'Unknown' }}</span>
          <span class="time-ago">{{ note.createdAt | timeAgo }}</span>
          @if (note.note) {
            <p class="note-text">{{ note.note }}</p>
          }
          @if (note.images?.length) {
            <div class="note-images">
              @for (image of note.images; track image) {
                <img [src]="image" alt="Note image" class="note-image" (click)="openImageDialog(note)" />
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
